import { SharedState } from '@trello/shared-state';

export const inboxSelectedCardsSharedState = new SharedState<Set<string>>(
  new Set(),
);
